import React, { Component } from 'react'

class HideChat extends Component {
  
  constructor(props) {
    super(props);

  }

  render () {
    if (this.props.isEntryPointExpanded) {
      return null
    }

    return (
      <div className="hide-chat" onClick={this._hideChat}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </div>
    )
  }

  _hideChat = () => {
    document.querySelector('#twilio-chat-component').style.display = 'none'
  }
}

export default HideChat
